import type { Link, MenuItems } from '@wix/public-schemas'
import { ReactElement } from 'react'

export type UnresolvedMenuItem = {
	id: string
	label: string
	link?: Link
	isVisible?: boolean
	container?: ReactElement
	items?: Array<UnresolvedMenuItem>
}

export type UnresolvedMenuItems = {
	id: string
	type: 'MenuItems'
	name: string
	items: Array<UnresolvedMenuItem>
}

const resolveItems = (items: Array<UnresolvedMenuItem>): MenuItems => {
	return items
		.filter((item) => item.isVisible)
		.map((item) => {
			const { id, label, link, container, items: subMenuItems } = item
			return {
				id,
				label,
				link,
				container,
				items: subMenuItems ? resolveItems(subMenuItems) : [],
			}
		})
}

export type MenuItemsResolver = (menuItems: UnresolvedMenuItems | UnresolvedMenuItem) => MenuItems
export const resolveMenuItems: MenuItemsResolver = (menuItems) => {
	return resolveItems(menuItems.items || [])
}
